import { BasePopover } from './components/BasePopover';
import PopoverPoints from './components/PopoverPoints';

export const Popover = BasePopover;

Popover.Points = PopoverPoints;
